export default "__VITE_ASSET__CWy1wnI6__"